import React, { useEffect, useState } from 'react';
import { Trash } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { ResponsiveDialog } from '@shared/components/ResponsiveDialog';
import { Box, ButtonV2, CancelButton, SpacingStack, TextV2 } from '@withjoy/joykit';
import { drawerOverrides } from '@shared/components/ResponsiveDialog/ResponsiveDialog.styles';
import { useTranslation } from '@shared/core';
import { useDeleteDialog } from './DeleteDialog.context';

export const DeleteDialog: React.FC = React.memo(props => {
  const { t2 } = useTranslation('joykit');
  const travelDelete = t2('deleteDialog');

  const { dialogData, closeDialog } = useDeleteDialog();

  const [isOpen, setIsOpen] = useState<boolean>(!!dialogData);
  const [loading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(!!dialogData);
  }, [dialogData]);

  if (!dialogData) return null;

  const { id, title, message, btnCancel, btnConfirm } = dialogData;

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      if (dialogData?.onConfirm) {
        await dialogData.onConfirm();
      }
    } catch (error) {}
    setIsLoading(false);
    closeDialog({ confirmed: true, id });
  };

  const handleCancel = () => {
    closeDialog({ confirmed: false });
  };

  return (
    <ResponsiveDialog
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      hideDivider
      removeBodyPadding
      hasCloseButton={false}
      drawerOverrides={{
        ...drawerOverrides,
        Content: {
          props: {
            ...drawerOverrides.Content?.props,
            boxShadow: '0px -7px 16px -8px rgba(0, 0, 0, 0.3), 0px -10px 27px -5px rgba(44, 41, 37, 0.25)',
          },
        },
        Body: { props: { ...drawerOverrides.Body?.props, paddingX: 6, paddingBottom: 8, paddingTop: 8 } },
      }}
      dialogOverrides={{
        Content: { props: { width: ['100%', pxToRem(480)] } },
        Body: { props: { paddingX: 8, paddingY: 8 } },
      }}
    >
      <SpacingStack spacing={8}>
        <SpacingStack
          spacing={6}
          maxWidth={pxToRem(320)}
          marginX="auto"
        >
          <TextV2
            as="h3"
            typographyVariant="hed6"
            textAlign="center"
          >
            {title || travelDelete.title}
          </TextV2>
          <TextV2
            as="p"
            typographyVariant="body2"
            color="mono12"
            textAlign="center"
          >
            {message || travelDelete.message}
          </TextV2>
        </SpacingStack>
        <Box width="100%">
          <ButtonV2
            intent="destructive"
            onClick={handleConfirm}
            width="100%"
            startIcon={<Trash />}
            loading={loading}
            disabled={loading}
          >
            {btnConfirm || travelDelete.deleteCta}
          </ButtonV2>
          <CancelButton
            marginRight="auto"
            onClick={handleCancel}
            width="100%"
            marginTop={5}
          >
            {btnCancel || travelDelete.cancelCta}
          </CancelButton>
        </Box>
      </SpacingStack>
    </ResponsiveDialog>
  );
});
